import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Router } from '@angular/router';
import { GraphqlService } from './graphql.service';
import { SessionService } from './Session.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private googleAnalyticsId: string;
  private googleGTMId: string;
  private renderer2: Renderer2;
  private scriptsLoaded: boolean = false;
  private isAnalyticsEnabled: boolean = false;
  constructor(
    private rendererFactory2: RendererFactory2,
    @Inject(DOCUMENT) private _document: Document,
    private graphQlService: GraphqlService,
    private _router: Router, private session: SessionService) {
    this.renderer2 = this.rendererFactory2.createRenderer(null, null);
  }

  init() {
    this.graphQlService.getAnalyticsStatus().subscribe((status: string) => {

      if (status != "" && status.endsWith("Enabled")) {
        this.addGtmScript(status.toString().split("~~~~")[0]);
        this.addGtmIframe(status.toString().split("~~~~")[0]);
        this.isAnalyticsEnabled = true;
      }

    });

    if (!this.scriptsLoaded) {
      if (this.session.analticsTrackingId != undefined && this.session.analticsTrackingId != null && this.session.analticsTrackingId != "") {
        if (this.session.analticsTrackingId != "Disabled") {
          this.googleAnalyticsId = this.session.analticsTrackingId;
          this.insertMainScript();
        }
      }
      else {
        this.graphQlService.getAnalyticsTrackingId().subscribe((trackingId: string) => {
          if (trackingId != "" && trackingId != "Disabled") {
            this.googleAnalyticsId = trackingId;
            this.insertMainScript();
            this.session.SetAnalticsTrackingIdValue(trackingId);
          }
        });
      }
    }
  }


  private insertMainScript() {
    if (this.googleAnalyticsId != "" && this.googleAnalyticsId != "Disabled") {
      const script: HTMLScriptElement = this.renderer2.createElement('script');
      script.async = true;
      script.onload = this.insertSecondHalfOfScript.bind(this);
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.googleAnalyticsId.toString().split("~~~~")[0]}`;
      this.renderer2.insertBefore(this._document.head, script, this._document.head.firstChild);
    }
  }

  private insertSecondHalfOfScript() {
    if (this.googleAnalyticsId != "" && this.googleAnalyticsId != "Disabled") {
      const script: HTMLScriptElement = this.renderer2.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.googleAnalyticsId.toString().split("~~~~")[1]}`;
      this.renderer2.insertBefore(this._document.head, script, this._document.head.firstChild);
      script.onload = () => {
        this.scriptsLoaded = true;
      };
    }
  }

  private addGtmScript(gtmId: string): void {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    this.renderer2.insertBefore(this._document.head, gtmScript, this._document.head.firstChild);
  }

  private addGtmIframe(gtmId: string): void {
    const gtmIframe = document.createElement('noscript');
    gtmIframe.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.renderer2.insertBefore(this._document.body, gtmIframe, this._document.body.firstChild);
  }
}
